import { BusinessTypesMapping } from 'api/client/mapping/business-types-mapping';
import { DeviationTeamsMapping } from 'api/client/mapping/deviation-teams-mapping';
import { DeviationTeamsClient, IDeviationTeamDetailDTO } from 'api/swagger/ApiClient';
import { autoinject } from 'aurelia-framework';
import { Redirect, RouteConfig, Router } from 'aurelia-router';
import { DialogHelper } from 'framework/aurelia_dialogs/dialog-helper';
import { log } from 'framework/script_utilities/dev-decorators';
import { DeviationTeamModel } from 'model/forms/deviation-team-model';
import { SystemUserWrapper } from 'model/support-types';
import { LookupsService } from 'services/lookups-service';
import { requireServices } from 'support/activation';
import { HOME_ROUTE } from 'support/settings';

@autoinject
export class AdminDeviationTeamsScreen {
  route: RouteConfig = null;
  deviationTeams: DeviationTeamModel[] = [];
  isEditing = false;
  loaded = false;

  constructor(private lookups: LookupsService, private api: DeviationTeamsClient, private router: Router, private dialogHelper: DialogHelper, private deviationTeamsMapping: DeviationTeamsMapping, private businessTypesMapping: BusinessTypesMapping) {
  }

  async canActivate() {
    await requireServices(this.lookups);
  }

  @log('debug')
  async activate(params, route: RouteConfig) {
    this.route = route;
  }

  bind() {
    this.initialize();
  }

  private async initialize() {
    this.bindDetail(await this.api.getAll());
    this.loaded = true;
  }

  async canDeactivate() {
    if (this.deviationTeams.some(x => x.isEditing()) && !await this.dialogHelper.confirm({ dialogTitle: 'Leave without saving?', message: 'You haven\'t saved the form yet. If you proceed, your changes will be lost!', okTitle: 'Leave without saving', cancelTitle: 'Stay here!' }))
      return new Redirect((this.router.history as any).previousLocation, { trigger: false, replace: false });
  }

  @log('debug')
  private bindDetail(dtos: IDeviationTeamDetailDTO[]) {
    this.deviationTeams = dtos.map(x => ({
      data: this.deviationTeamsMapping.mapToDeviationTeamDataModel(x),
      membersWrapper: x.members.map(m => ({
        user: this.businessTypesMapping.mapUserToUserContact(m),
        userId: m.id
      } as SystemUserWrapper)),
      regionDirectors: x.regionDirectors.map(d => this.deviationTeamsMapping.mapToDeviationTeamRegionDirectorDataModel(d)),
      isEditing: null
    } as DeviationTeamModel));
  }

  get homeRoute() {
    return HOME_ROUTE;
  }

  get title() {
    return 'Deviation Teams';
  }
}
